import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ name, className }) => {
  const Svg = require(`./assets/${name}.svg`).default;

  return (
    <Svg className={className} />
  );
};

Icon.propTypes = {
  name: PropTypes.string,
  className: PropTypes.any,
};

export default Icon;
